import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import clsx from "clsx";
import { useEffect } from "react";

type TanStackQueryDevtoolsProps = {
  isOpen: boolean;
};

export function TanstackQueryDevtools({ isOpen }: TanStackQueryDevtoolsProps) {
  useEffect(() => {
    const btn: HTMLButtonElement | null = document.querySelector(
      isOpen ? ".tsqd-open-btn" : ".tsqd-minimize-btn",
    );

    btn?.click();
  }, [isOpen]);

  useEffect(() => {
    localStorage.setItem("TanstackQueryDevtools.open", "false");
  }, []);

  return (
    <div
      className={clsx([
        "[&_.tsqd-open-btn-container]:pointer-events-none! [&_.tsqd-open-btn-container]:opacity-0!",
        "[&_.tsqd-minimize-btn]:hidden!",
        "[&_.tsqd-main-panel]:min-h-[60dvh]! [&_.tsqd-queries-container]:overflow-x-auto",
      ])}
    >
      <ReactQueryDevtools initialIsOpen={false} buttonPosition="bottom-left" />
    </div>
  );
}
